import {
  CancelModalBodyContainer,
  CancelModalRadioGroup,
  CancelModalStyledBody,
} from './ChkCancelModalStyledComponents';
import { CancelModalWrapper } from './ChkCancelModalWrapper';

export const ChkCancelModal = {
  Wrapper: CancelModalWrapper,
  ReasonsGroup: CancelModalRadioGroup,
  BodyContainer: CancelModalBodyContainer,
  StyledBody: CancelModalStyledBody,
};
